import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@app/shared';

import { OAuthAuthorizeComponent } from './oauth-authorize/oauth-authorize.component';
import { OAuthRoutingModule } from './oauth-routing.module';

@NgModule({
  declarations: [OAuthAuthorizeComponent],
  imports: [CommonModule, FormsModule, OAuthRoutingModule, SharedModule, TranslateModule]
})
export class OAuthModule {}
